import { ValidatorPosition } from '../../position/validator-position';
export const config = {
    value: 'checkUploadIsComplete',
    position: [
        ValidatorPosition.filter,
        ValidatorPosition.form,
        ValidatorPosition.formDialog,
        ValidatorPosition.cnArrayTable,
        ValidatorPosition.cnArraySubAreaCard,
    ],
};
